import {
	AboutProject
} from '../../../public/static/AboutProject.js'
import {
	proxy
} from '../proxy'
import {
	initMessage
} from '../message-console'
import commonM from './common/common';
import {dorequest,ApiUrl} from './common/request.js'
function Project(option) {
	this instanceof Project && this.initProject(option);
}

Project.prototype.initProject = function(option) {
	this._name = AboutProject.ProjectName;
	this._version = AboutProject.Version;
	this._hasOption = option ? true : false;
	this._option = option;
	this.base = commonM;
	
	this.ApiUrl=ApiUrl

	initMessage(this);
	this.base.http=dorequest;
	if (this._hasOption) {
		let tempkey = {};
		for (const part in option) {
			this[`_${part}`] = option[part]; //copy to current Object
			for (const key in option[part]) {
				if (key in tempkey) {
					this.warn(`
					${this._name}:
					duplicate key[${key}] in ${part}.you should check your option.`)
				}
				proxy(this, `_${part}`, key);
				tempkey[key] = key;
			}
		}
	}
}
export default Project;
